import * as React from 'react';
import { connect } from 'react-redux';
import * as Metadata from '../../../entities/Metadata';
import { ApplicationState } from '../../../store';
import { resolveTimephasedFieldFromStore } from '../../../services/TimephasedConfigService';
import { DisplayFieldService } from '../DisplayFieldService';
import NumberFilter, { NumberFilterValue } from './NumberFilter';
import { Validator } from '../../../validation';

type OwnProps = {
    field: Metadata.Field;
    value?: NumberFilterValue;
    onEditComplete: (value: NumberFilterValue) => void;
};

type StateProps = {
    resolvedField: Metadata.Field;
    validator: Validator;
};

type Props = OwnProps & StateProps;

const TimephasedValueFilterComponent: React.FunctionComponent<Props> = (props) => {
    return (
        <NumberFilter
            field={props.resolvedField}
            validator={props.validator}
            value={props.value}
            onEditComplete={props.onEditComplete}
        />
    );
};

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps): StateProps => {
    const resolvedField = resolveTimephasedFieldFromStore(state.fields, ownProps.field) ?? ownProps.field;
    return {
        resolvedField,
        validator: DisplayFieldService.buildValidator(resolvedField, true)
    };
};

const TimephasedValueFilter = connect(mapStateToProps)(TimephasedValueFilterComponent);

export default TimephasedValueFilter;
